import { useState, useEffect } from 'react';
import orderBy from 'lodash/orderBy';

function matchBreakpoint(breakpoints = []) {
  let breakpoint = null;

  breakpoints.forEach(({ name, width }) => {
    if (window.innerWidth >= width) {
      breakpoint = name;
    }
  });

  return breakpoint;
}

export default (config = {}) => {
  const breakpoints = orderBy(
    Object.keys(config).map(key => ({
      name: key,
      width: config[key],
    })),
    'width'
  );
  const [breakpoint, setBreakpoint] = useState();

  useEffect(() => {
    const onResize = () => {
      setBreakpoint(matchBreakpoint(breakpoints));
    };
    window.addEventListener('resize', onResize);
    onResize();
    return function cleanup() {
      window.removeEventListener('resize', onResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return breakpoint;
};
